//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'placing-type-radios',
  props: {
    value: String | Number,
    bccBalance: {
      type: String | Number,
      default: 0,
    },
    currencyCode: {
      type: String,
      default: window.localStorage.getItem('currency_code') || 'CNY',
    },
  },
  data(){
    return {
      placingType: 1,
    };
  },
  mounted(){
    this.$emit('input', this.placingType);
  },
  watch: {
    placingType(){
      this.$emit('input', this.placingType);
    },
  },
}



// WEBPACK FOOTER //
// ./src/views/hotel-booking/components/PlacingTypeRadios.vue